import { createSelector } from "reselect";

import { App } from "../Enums/App";
import { AppView } from "../Enums/AppView";
import { IRootReducer } from "../Reducers/RootReducer";
import { IAppReducerState } from '../Reducers/AppReducer';
import { IHeaderNavDisplay } from "../Models/IHeaderNavDisplay";

export const currentAppSelector = createSelector(
    (state: IRootReducer) => state.appReducer.currentApp,
    (app: App) => app
);

export const currentAppViewSelector = createSelector(
    (state: IRootReducer) => state.appReducer.appView,
    (view: AppView) => view
);

export const currentAppIsPastIntroSelector = createSelector(
    (state: IRootReducer) => state.appReducer,
    (appState: IAppReducerState) => appState.appsPastIntro.has(appState.currentApp),
);

export const headerNavDisplay = createSelector(
    (state: IRootReducer) => state.appReducer.headerNavDisplay,
    (headerNavDisplay: IHeaderNavDisplay) => headerNavDisplay,
);
